// @flow

import * as React from "react";
// import moment from "moment";
import { connect } from "react-redux";
import QRCode from "qrcode"
import _ from "lodash";
import { push } from "@lagunovsky/redux-react-router";

// import Config from "@Config";
import actions from "@actions";
// import ApiFactory from "@apis/APIFactory";
// import Button from "@components/atoms/Button";
// import CompCountdown from "@components/atoms/CompCountdown";
// import TextButton from "@components/atoms/TextButton";
// import ProductImage from "@components/atoms/ProductImage";
// import * as GoogleAnalytics from "@utils/GoogleAnalytics";

import { type VoucherType, type ProfileType } from "@SharedTypes";

import JCLogo from "@assets/images/JCafeLogo.svg"
import JCDrink from "@assets/images/jc-drinks.png"

const { useEffect, useState, useRef } = React;

type PropsType = {
    voucher: VoucherType,
    imageBasePath: string,
    user: ProfileType,
    active: boolean,
    // onAddToCart: () => void,
    onClose: () => void,
    isComp?: boolean,
    compImageBasePath: string,
    compCodeStores: any,
    paymentSupport: any,
    applyCompCode: any,
    addVoucher: any,
    push: any,
    storeId: any,
    openAlertModal: any,
    closeAlertModal: any,
    closeVoucherModal: any,
    coffeeLoyaltyCta?: any
};

const QRcodeOverlay = ({
    // voucher,
    // imageBasePath,
    // compImageBasePath,
    user,
    active,
    // isComp,
    // onAddToCart = () => {},
    onClose = () => { },
    // compCodeStores,
    // paymentSupport,
    // applyCompCode,
    // addVoucher,
    // push,
    // storeId,
    // openAlertModal,
    // closeAlertModal,
    // closeVoucherModal,
    // coffeeLoyaltyCta
}: PropsType): React.Node => {
    const [showQRcode, setShowQRcode] = useState(false);
    const [qrSvg, setQrSvg] = useState("");
    // Format loyalty card number with spaces (e.g. "61000 421 231 871")
    const formatLoyaltyCard = (cardNo) => {
        if (!cardNo) return "";
        // Try to group as 5-3-3-3 (e.g. 61000 421 231 871)
        const match = cardNo.match(/^(\d{5})(\d{3})(\d{3})(\d{3})$/);
        if (match) {
            return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
        }
        // fallback: group by 4
        return cardNo.replace(/(.{4})/g, "$1 ").trim();
    };

    // Render the QR code SVG using qrcode library
    useEffect(() => {
        if (user.loyalty_card_no) {
            QRCode.toString(user.loyalty_card_no, { type: "svg", margin: 1 }, function (err, svg) {
                if (!err) {
                    setQrSvg(svg);
                } else {
                    setQrSvg("");
                    console.log("QR Code Error: ", err);
                }
            });
        }
    }, [user.loyalty_card_no]);

    // Auto close the QR code when the component is not active
    useEffect(() => {
        if (!active) {
            setShowQRcode(false);
        }
    }, [active]);

    // if (!voucher) {
    //     return null;
    // }

    return (
        <div className="barcode-overlay">
            <div className="barcode-overlay__content">
                <div className="barcode-overlay__content__logo">
                    <img
                        src={JCLogo}
                        alt={"Jack's Cafe logo"}
                    />
                </div>
                <p className="barcode-overlay__content__caption">
                    Jack's Cafe Loyalty
                </p>
                <h1 className="barcode-overlay__content__heading">
                    <span className="barcode-overlay__content__heading__name">
                        {user.first_name}'s
                    </span>
                    <br />
                    Reward card
                </h1>
                <div className="barcode-overlay__content__img">
                    <img
                        src={JCDrink}
                        alt={"Jack's Cafe drinks"}
                    />
                </div>
                <div
                    className={`barcode-overlay__content__barcode ${
                        showQRcode ? "is-active" : ""
                        }`}
                >
                    <p className="barcode-overlay__content__barcode__heading">
                        Scan QR code at cashier
                    </p>
                    {/* Render QR SVG with the same CSS class for styling */}
                    <span
                        className="barcode-overlay__content__barcode__img"
                        dangerouslySetInnerHTML={{ __html: qrSvg }}
                    />
                    {/* Display formatted loyalty card number below QR code */}
                    {user.loyalty_card_no && (
                        <div className="barcode-overlay__content__barcode__number">
                            {formatLoyaltyCard(user.loyalty_card_no)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any, ownProps: any): any => {
    return {
        user: state.user,
        imageBasePath: state.vouchers.image_base_path,
        compImageBasePath: state.vouchers.comps_image_base_path,
        compCodeStores: _.isArray(
            _.get(ownProps, "voucher.stores_ids_constraints")
        )
            ? _.compact(
                ownProps.voucher.stores_ids_constraints.map((id: any): any =>
                    _.find(state.stores.list, { store_id: id })
                )
            )
            : null,
        paymentSupport: state.device.paymentSupport,
        storeId: _.get(state, "session.selectedStore.store_id", 0)
    };
};

export default connect(
    mapStateToProps,
    {
        applyCompCode: actions.cart.applyCompCode,
        addVoucher: actions.vouchers.voucherDeeplink,
        openAlertModal: actions.globalModals.openAlertModal,
        closeAlertModal: actions.globalModals.closeAlertModal,
        closeQRcodeOverlay: actions.globalModals.closeQRcodeOverlay,
        push: push
    }
)(QRcodeOverlay);
